import React, { useState, useEffect } from 'react';

import {
  LocalGasStation,
  LocalShipping,
  Timer,
  Opacity,
} from '@material-ui/icons';

import { Select, Autocomplete } from '~/components/Form';
import { t, number } from '~/helpers';
import api from '~/services/api';

import { Card } from '..';

import { Container, Items, Item, Form } from './styles';

export default function Gas() {
  const [data, setData] = useState({
    consumomediohodometro: 0,
    consumomediohorimetro: 0,
    tempomedioabastecimento: 0,
    veiculosabastecidos: 0,
    veiculoscadastrados: 0,
    volumeabastecido: 0,
  });
  const [initials, setInitials] = useState();

  /**
   * request data in URL
   *
   * @param {Object} params
   */
  async function handleData(params) {
    const request = await api.get('dashboardsvolumesabastecidos', { params });

    await setData(request.data);
    await setInitials(params || { periodo: '1' });
  }

  useEffect(() => {
    handleData();
  }, []);

  return (
    <Card
      icon={<LocalGasStation />}
      title={t('s.dashboard.dashvolumeabastecimento.volumedeabastecimento')}
      onSubmit={(value) => handleData(value)}
      initials={initials}
      filter={
        <Form>
          <Select
            name="periodo"
            label={t('s.dashboard.dashvolumeabastecimento.periodo')}
            options={[
              {
                value: '1',
                label: t('s.dashboard.dashvolumeabastecimento.ultimas24horas'),
              },
              {
                value: '7',
                label: t('s.dashboard.dashvolumeabastecimento.ultimasemana'),
              },
              {
                value: '15',
                label: t('s.dashboard.dashvolumeabastecimento.ultimos15dias'),
              },
              {
                value: '30',
                label: t('s.dashboard.dashvolumeabastecimento.ultimos30dias'),
              },
            ]}
          />

          <Autocomplete
            name="idposto"
            label="nomeposto"
            url="postoscomboios"
            unique="idposto"
            title={t('s.configuracao.arqueacao.idposto')}
          />

          <Autocomplete
            name="idproduto"
            label="nomeproduto"
            url="produtos"
            unique="idproduto"
            title={t('s.menu.configuracao.produto')}
          />
        </Form>
      }
    >
      <Container>
        <hgroup>
          <h1>{number(data.volumeabastecido, 1)}</h1>
          <h2>{t('s.dashboard.dashvolumeabastecimento.litros')}</h2>
        </hgroup>

        <Items>
          <Item>
            <LocalShipping style={{ color: 'red' }} />
            <p>
              {t('s.dashboard.dashvolumeabastecimento.veiculosabastecidos')}
            </p>
            <h1>{data.veiculosabastecidos}</h1>
            <p>de</p>
            <p>{data.veiculoscadastrados}</p>
          </Item>

          <Item>
            <Timer style={{ color: 'yellow' }} />
            <p>
              {t('s.dashboard.dashvolumeabastecimento.tempomedioabastecimento')}
            </p>
            <h1>
              {number(data.tempomedioabastecimento, 1)}
              <span style={{ marginLeft: '0.5rem' }}>min</span>
            </h1>
            <p>{t('s.dashboard.dashvolumeabastecimento.porveiculo')}</p>
          </Item>

          <Item>
            <Opacity style={{ color: 'green' }} />
            <p>{t('s.dashboard.dashvolumeabastecimento.mediadeconsumo')}</p>
            <h1>{number(data.consumomediohodometro, 1)}</h1>
            <p>km/l</p>
            <h1>{number(data.consumomediohorimetro, 1)}</h1>
            <p>l/h</p>
          </Item>
        </Items>
      </Container>
    </Card>
  );
}
